import styled from 'styled-components';

import Text from 'xpi-black-ui/Base/Typography/Text/styles';

export const Footer = styled.footer`
  width: 100%;
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.bgColor};

  ${Text}:last-child {
    margin-left: 8px;
    margin-right: 30px;
    color: ${({ theme }) => theme.textColorWhite};
  }
`;
